module.exports = "<div class=\"modal-header\">\n  <h2>{{'outbound.message.modal_delete.show.title' | translate}}</h2>\n</div>\n<p>\n  <strong translate=\"outbound.message.modal_delete.body\"></strong>\n</p>\n<footer>\n  <div class=\"action-buttons\">\n    <button class=\"dark button\" ng-click=\"delete(message)\">{{'common.buttons.delete' | translate}}</button>\n    <button class=\"button\" ng-click=\"cancel()\">{{'common.buttons.cancel' | translate}}</button>\n  </div>\n</footer>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/messageOutbound/active_promo/deleteConfirm.modal.html
 ** module id = 646
 ** module chunks = 0
 **/